<script setup lang="ts">
import SearchHints from '@/features/SearchHints/ui/index.vue';
import useGlobalSearch from '@/shared/composables/useGlobalSearch';

const {
  searchValue,
  isShowHint,
  itemsList,
  onHide,
  showHints,
  searchHandler,
  submitHandler,
} = useGlobalSearch();

const isMobile: boolean = useIsMobile();
</script>

<template>
  <section :class="['main', { _mobile: isMobile }]" data-testid="main-section">
    <div class="main__inner">
      <div class="main__content">
        <h1 class="main__content-title" data-testid="main-title">
          Надежные юристы в вашем городе
        </h1>
        <span class="main__content-subtitle" data-testid="main-subtitle">
          С отзывами <br />
          и бесплатной записью
        </span>
        <form class="main__form" data-testid="main-form" @submit.prevent="submitHandler">
          <label class="main__form-title" for="main-search" data-testid="main-form-title">
            Что будем искать?
          </label>
          <div class="main__form-item">
            <div class="main__form-input-wrapper" data-testid="main-form-input-wrapper">
              <AppInput
                v-model="searchValue"
                class="main__form-input"
                placeholder="Город, специализация, услуги, имя"
                type="text"
                :attr="{ id: 'main-search', name: 'search', autocomplete: 'off' }"
                @input="searchHandler"
                @focus="showHints"
              />
              <div v-show="isShowHint" class="main__form-hints">
                <SearchHints
                  :key="searchValue"
                  :items="itemsList"
                  :query="searchValue"
                  @hide="onHide"
                />
              </div>
            </div>
            <div class="main__form-button" data-testid="main-form-button">
              <AppButton is-big button-text="Найти юриста" type="submit" />
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<style lang="less">
.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  background: url('/images/main-page/main-bg.webp') center no-repeat;
  background-size: cover;

  &__inner {
    .container-d();

    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    padding-top: 245px;
    padding-bottom: 173px;
  }

  &__content {
    z-index: 2;
    width: 74.7%;

    @media @tablet {
      width: 100%;
    }
  }

  &__content-title {
    font-size: 54px;
    font-weight: 800;
    line-height: 100%;
    max-width: 555px;
    margin-bottom: @size-x5;
  }

  &__content-subtitle {
    font-size: @size-x6;
    font-weight: 400;
    line-height: @size-x7;

    br {
      display: none;
    }
  }

  &__form {
    margin-top: 76px;
  }

  &__form-title {
    display: block;
    font-size: 14px;
    line-height: 15px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  &__form-item {
    display: flex;
    gap: @size-x5;
    align-items: center;
    width: 100%;
  }

  &__form-input-wrapper {
    position: relative;
    width: 100%;
    max-width: 632px;
  }

  &__form-button {
    width: 100%;
    max-width: 236px;
    margin-right: 0;
  }

  &__form-hints {
    .box-shadow();

    background: @color-black-haze;
    position: absolute;
    top: 48px;
    z-index: 5;
    width: 100%;
    max-width: 632px;
    border-radius: @main-size;
  }

  &__form-input input {
    padding-left: @size-x5;
  }

  &._mobile {
    background: url('/images/main-page/main-bg-mobile.webp') center no-repeat;
    background-size: cover;
  }

  &._mobile &__inner {
    .container-m();

    padding-top: 107px;
    padding-bottom: 48px;
  }

  &._mobile &__content {
    width: 100%;
  }

  &._mobile &__content-title {
    font-size: @size-x9;
    font-weight: 700;
    line-height: 130%;
    max-width: 296px;
    margin-bottom: 6px;
  }

  &._mobile &__content-subtitle {
    font-size: @size-x6;
    line-height: 130%;

    br {
      display: block;
    }
  }

  &._mobile &__form {
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 44px;
  }

  &._mobile &__form-item {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
